import { customerSelectFrom, postMessageTypes } from "../../constants/postMessageFileds";
import { APP_INFO, AUTH_TOKEN } from "../../constants/storageKeys";
import { onAppInitialValuesComplete } from "../../store/slices/appInitialSlice";
import { getCustomers, } from "../../store/slices/customerListSlice";
import { onSelectdDepartmentList, onSelectDivisionList, onSelectGroupCodes } from "../../store/slices/erpValuesSlice";
import { onSelectFreePaymentCustomer, } from "../../store/slices/freePaymentSlice";
import { onIntegrationComplete } from "../../store/slices/IntegrationSlice";
import { onSelectOrderLinkListCustomer } from "../../store/slices/linkListSlice";
import { onSelectOrderReportCustomer, onSingleIntegrationComplete, } from "../../store/slices/orderReportSlice";
import { onSelectCurrencyTypes, onSelectCustomer, } from "../../store/slices/sheetPaymentFiltersSlice";
import { onBankMatchSelect, onErpParametersSelect } from "../../store/slices/erpParameterSlice";
import appHelpers from "./appHelpers";
import { onSelectErpIntegrationCustomer } from "../../store/slices/erpIntegrationCustomerSlice";
import {  onErpContractSelect } from "../../store/slices/vpDetailSlice";

export function routeReceivedMessage(dispatch, message) {



  const { data } = message;
  try {
    var response = (data)

    switch (response.responseType) {
      case postMessageTypes.selectLinkListGroupCodes:
        var groupCodes = JSON.parse(response.responseBody);

        dispatch(onSelectGroupCodes({
          code1List: JSON.parse(groupCodes.code1List),
          code2List: JSON.parse(groupCodes.code2List),
          code3List: JSON.parse(groupCodes.code3List),
          code4List: JSON.parse(groupCodes.code4List),
          code5List: JSON.parse(groupCodes.code5List),
          netsisGroupCodes: JSON.parse(groupCodes.netsisGroupCodes),
        }));


        break;
      case postMessageTypes.selectDepartmentList:
        var department = JSON.parse(response.responseBody);

        dispatch(onSelectdDepartmentList(department));

        break;
      case postMessageTypes.selectDivisionList:
        var divisions = JSON.parse(response.responseBody);
        dispatch(onSelectDivisionList(divisions));

        break;
      case postMessageTypes.selectCustomerListByFilter:
        var customerstr = JSON.parse(response.responseBody).Data;
        var currentList = JSON.parse(customerstr) || [];

        var callBackParams = JSON.parse(response.callbackParameters);
        var params ={
          SelectedAmountType : callBackParams.SelectedAmountType,
          BalanceStart: callBackParams.BalanceStart,
          BalanceEnd: callBackParams.BalanceEnd,
          customers : currentList
        }

        dispatch(getCustomers({ params }));


        break;
      case postMessageTypes.getCustomerInfo:

        var customerInfo = JSON.parse(response.responseBody);
        var callBackParams = JSON.parse(response.callbackParameters);


        if (callBackParams.customerSelectFrom == customerSelectFrom.fromFreePayment) {
          dispatch(onSelectFreePaymentCustomer(customerInfo));
        } else if (callBackParams.customerSelectFrom == customerSelectFrom.fromSheetPayment) {
          dispatch(onSelectCustomer(customerInfo));
        } else if (callBackParams.customerSelectFrom == customerSelectFrom.fromOrderReport) {
          dispatch(onSelectOrderReportCustomer(customerInfo));

        } else if (callBackParams.customerSelectFrom == customerSelectFrom.fromLinkList) {
          dispatch(onSelectOrderLinkListCustomer(customerInfo));
        }
        else if (callBackParams.customerSelectFrom == customerSelectFrom.fromErpIntegration) {
          customerInfo.orderid = callBackParams.orderid;
          dispatch(onSelectErpIntegrationCustomer(customerInfo));
        }else if (callBackParams.customerSelectFrom == customerSelectFrom.fromVpInformations) {
          var code = customerInfo.code;
          var responseBody = {
            bankCode: code
          }
          dispatch(onBankMatchSelect({responseBody: JSON.stringify(responseBody)}));
        }
        break;

      case postMessageTypes.getDefaultInformation:

        var callBackParams = JSON.parse(response.callbackParameters);

        dispatch(onAppInitialValuesComplete(callBackParams.unique));
        var body = response.responseBody;
        try {
          var params = JSON.parse(body);
          var pastVkn = appHelpers.getTaxNumber();
          var newVkn = params?.taxNumber != null ? params.taxNumber : params?.tcNumber;
          if (pastVkn != newVkn) {
            localStorage.removeItem(AUTH_TOKEN);
          }
          
          localStorage.setItem(APP_INFO, body);
        } catch (error) {

        }

        break;
      case postMessageTypes.getLicenceKey:

        break;

      case postMessageTypes.getClientInfo:

        break;

      case postMessageTypes.integration:

        dispatch(onIntegrationComplete(response));

        break;
      case postMessageTypes.singleIntegration:

        dispatch(onSingleIntegrationComplete(response));

        break;
      case postMessageTypes.openErpBankList:

        dispatch(onBankMatchSelect(response));

        break;
        
      case postMessageTypes.selectContractList:

      dispatch(onErpContractSelect(response));

      break;
      case postMessageTypes.selectCurrencyList:
        var currencyList = JSON.parse(response.responseBody);
        dispatch(onSelectCurrencyTypes(currencyList));

        break;

      case postMessageTypes.selectErpParameterList:

        var erpParameters = JSON.parse(response.responseBody);

        if (appHelpers.getPlatform() == "NETSIS") {
          dispatch(onErpParametersSelect({
            ProjectCodes: JSON.parse(erpParameters.ProjectCodes),
            SalesmanCodes: JSON.parse(erpParameters.SalesmanCodes),
            ReferenceCodes: JSON.parse(erpParameters.ReferenceCodes),
            DekontSerialCodes: JSON.parse(erpParameters.DekontSerialCodes),
          }));

        } else {
          dispatch(onErpParametersSelect({
            ProjectCodes: JSON.parse(erpParameters.ProjectCodes),
            SalesmanCodes: JSON.parse(erpParameters.SalesmanCodes),
            SpecialCodes: JSON.parse(erpParameters.SpecialCodes),
            AuthCodes: JSON.parse(erpParameters.AuthCodes),
          }));

        }

        break;
      default:
        break;
    }

  } catch (error) {

  }
}


export const postWebViewMessage =(messageBody)=>{

  if (window.chrome.webview && window.chrome.webview.postMessage) {
    window.chrome.webview.postMessage(messageBody);
  }

}

export const selectGroupCodes = () => {

  var messageBody = { requestType: postMessageTypes.selectLinkListGroupCodes, requestBody: "" };
  postWebViewMessage(JSON.stringify(messageBody));

}
export const selectDivision = () => {
  var platform = appHelpers.getPlatform();
  if (platform !== "NETSIS") {
    var messageBody = { requestType: postMessageTypes.selectDivisionList, requestBody: "" };
    postWebViewMessage(JSON.stringify(messageBody));
  }



}
export const selectDepartment = () => {
  var platform = appHelpers.getPlatform();
  if (platform !== "NETSIS") {
    var messageBody = { requestType: postMessageTypes.selectDepartmentList, requestBody: "" };
    postWebViewMessage(JSON.stringify(messageBody));
  }
}